import { render, staticRenderFns } from "./AccountTwoFaStepGenerator.vue?vue&type=template&id=52e514f8&scoped=true"
import script from "./AccountTwoFaStepGenerator.vue?vue&type=script&lang=js"
export * from "./AccountTwoFaStepGenerator.vue?vue&type=script&lang=js"
import style0 from "./AccountTwoFaStepGenerator.vue?vue&type=style&index=0&id=52e514f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e514f8",
  null
  
)

export default component.exports